import { useEffect } from 'react';

export const useDashboardData = (getDashboardData, unloadDashboard) => {
    useEffect(() => {
        getDashboardData();

        return () => unloadDashboard();
    }, []);
};
